{
  "title": "Sähköpostit",
  "table": {
    "sent_at": "Lähetetty",
    "recipient": "Vastaanottaja",
    "subject": "Aihe",
    "type": "Tyyppi",
    "status": "Tila"
  },
  "status": {
    "PENDING": "Odottaa",
    "SENT": "Lähetetty",
    "FAILED": "Epäonnistui"
  },
  "types": {
    "EMAIL_VERIFICATION": "Sähköpostin vahvistus",
    "PASSWORD_RESET": "Salasanan nollaus",
    "COMPETITION_REGISTRATION_CONFIRMED": "Registration confirmed",
    "COMPETITION_REGISTRATION_WAITLISTED": "Registration waitlisted",
    "COMPETITION_REGISTRATION_CANCELLED": "Registration cancelled",
    "COMPETITION_REGISTRATION_WAITLIST_CONFIRMED": "Confirmed from waitlist",
    "FEEDBACK": "User feedback",
    "COMPETITION_START_TIMES_PUBLISHED": "Tee times published",
    "COMPETITION_PARTICIPANT_ADHOC": "Message to participants",
    "ROUND_RESULTS_PUBLISHED": "Round results published",
    "EMAIL_CHANGE_CONFIRMATION": "Email Change Confirmation",
    "EMAIL_CHANGE_NOTICE": "Email Change Notice"
  },
  "popover": {
    "body_label": "Viesti",
    "error_message_label": "Virheviesti"
  },
  "pagination": {
    "previous": "Edellinen",
    "next": "Seuraava",
    "page_of": "Sivu {{current}} / {{total}}"
  },
  "not_sent_yet": "(ei lähetetty)",
  "empty_state": "Ei sähköposteja",
  "refresh": "Refresh",
  "view_details": "View details",
  "copy_body": "Copy to clipboard"
}
